import { Component, OnInit } from '@angular/core';
import{ Router, ActivatedRoute } from '@angular/router';
import {UserService} from "../../services/user.service";

@Component({
	moduleId: module.id,
	selector: 'login',
	templateUrl: 'login.html',
	styleUrls: ['login.scss']
})

export class LoginComponent{
	email: string;
	password: string;
	private modalHide = [true];
	login(): void {
		//store a ref to our router so we can access it
		//in a callback
		let router = this.router;

		this.userService.login(this.email, this.password)
		.then(function(result){
			// TODO: if we didn't get a user back this was an error that the service
			// will be handling
			if (result) {
				router.navigate(['/dashboard'])
			}
		})
	}
	constructor(
			private userService: UserService,
			private router: Router,
      private route: ActivatedRoute
	) {}

	ngOnInit(): void {
		if (this.route.snapshot.queryParamMap.get('clearSession')) {
			this.userService.clearSession();
		} else if (this.userService.isLoggedIn()) {
			this.router.navigate(['/dashboard']);
		}

	};

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts